/**
 * Route for `export-to-csv-xlsx`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ExportToCsvXlsxPage } from "../features/export-to-csv-xlsx/ExportToCsvXlsxPage";

export const exportToCsvXlsxRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/export-to-csv-xlsx",
	component: ExportToCsvXlsxPage,
});

export default exportToCsvXlsxRoute;
